/**
 * 計助ダッシュボード: 表入力のクリップボード（Excel / Sheets 貼り付け）
 * チャート描画とは独立したユーティリティ。
 */

/** クリップボードの text/html から行を TAB 区切りのプレーンに変換（Excel/Sheets が plain を空にすることがある） */
function htmlTableToTsv(html: string): string {
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const rows = doc.querySelectorAll('tr');
    if (rows.length === 0) return '';
    const lines: string[] = [];
    rows.forEach((tr) => {
      const cells = tr.querySelectorAll('th, td');
      lines.push(
        [...cells].map((c) => (c.textContent ?? '').replace(/\r?\n/g, ' ').trim()).join('\t')
      );
    });
    return lines.join('\n');
  } catch {
    return '';
  }
}

/**
 * paste イベントからプレーン文字列を取得。
 * text/plain が空のとき text/html の表、またはレガシー type を試す。
 */
export function clipboardPlainTextFromEvent(e: Pick<ClipboardEvent, 'clipboardData'>): string {
  const cd = e.clipboardData;
  if (!cd) return '';
  const plain = cd.getData('text/plain');
  if (plain.trim()) return plain;
  const legacy = cd.getData('text');
  if (legacy.trim()) return legacy;
  const html = cd.getData('text/html');
  if (html?.trim()) {
    const fromHtml = htmlTableToTsv(html);
    if (fromHtml.trim()) return fromHtml;
  }
  return '';
}

/** Excel / 表からのコピー想定: タブ区切り・改行区切りを行列に分解（タブが無い複数行はカンマ区切りも解釈） */
export function parseClipboardTsvMatrix(text: string): string[][] {
  const normalized = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  if (!normalized.trim()) return [];
  const lines = normalized.split('\n');
  const hasTab = normalized.includes('\t');
  const useCommaCols =
    !hasTab && lines.some((line) => line.trim().length > 0 && line.includes(','));
  return lines.map((line) => {
    if (hasTab) return line.split('\t');
    if (useCommaCols && line.includes(',')) {
      return line.split(',').map((s) => s.trim());
    }
    return [line];
  });
}

/** 複数セル貼り付けなら true（単一セルはブラウザ既定の貼り付けに任せる） */
export function clipboardLooksLikeSpreadsheetGrid(text: string): boolean {
  const raw = text.trim();
  if (!raw) return false;
  if (raw.includes('\t') || raw.includes('\n') || raw.includes('\r')) return true;
  const matrix = parseClipboardTsvMatrix(raw);
  if (matrix.length > 1) return true;
  return (matrix[0]?.length ?? 0) > 1;
}
